<ng-container [ngSwitch]="candidateDataLoadState">
  <ng-container *ngSwitchCase="CandidateDataLoadState.Loaded">
    <valg-table
      [columnDefinition]="activeColumnDef"
      [data]="data"
      [itemName]="'parties_table.item_name' | translate"
      [title]="title | translate"
      [description]="isCandidateListTable ? 'parties_table.description_candidate_list' : 'parties_table.description'"
      [hasPagination]="false"
      [displayItemCount]="false"
      [lazyLoad]="true"
      [hasMainActionButton]="false">
      <h2 class="m-0 text--f20 text--500">{{ title | translate }}</h2>
      <ng-container content-position="pre-table" *ngIf="resultSummary !== undefined; else simpleSummary">
        <valg-dk-result-summary content-position="pre-table" [resultSummary]="resultSummary"></valg-dk-result-summary>
      </ng-container>
      <ng-template #simpleSummary>
        <valg-dk-simple-result-summary content-position="pre-table" [resultType]="resultType"></valg-dk-simple-result-summary>
      </ng-template>
    </valg-table>
  </ng-container>
  <div *ngSwitchCase="CandidateDataLoadState.NotLoaded" class="p-5">
    <h2 class="mt-0 text--f20 text--500">{{ title | translate }}</h2>
    {{ (isCandidateListTable ? "parties_table.candidate_list_not_loaded" : "parties_table.party_not_loaded") | translate}}
  </div>
  <div *ngSwitchCase="CandidateDataLoadState.Revoked" class="p-5">
    <h2 class="mt-0 text--f20 text--500">{{ title | translate }}</h2>
    {{"parties_table.revoked" | translate}}
  </div>
</ng-container>
